
import { createRouter, createWebHashHistory } from 'vue-router'
import NotFound from '@/pages/NotFound.vue'


// import Login from '@/pages/auth/LoginForm.vue'
// import DashboardHome from '@/pages/dashboard/DashboardHome.vue'


const routes = [
  // { path: '/login', component: Login, meta: { public: true } },
  { path: '/forgot-password', component: () => import('@/pages/auth/ForgotPassword.vue'), meta: { public: true } },
  { path: '/reset-password', component: () => import('@/pages/auth/ResetPassword.vue'), meta: { public: true } },
  // {
  //   path: '/',
  //   component: () => import('@/layouts/AdminLayout.vue'),
  //   children: [
  //     { path: '', name: 'Dashboard', component: DashboardHome },
  //     { path: 'users', component: () => import('@/pages/users/UsersList.vue') }
  //   ]
  // }
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound, meta: { public: true } }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})


export default router
